(function () {
  var cachedLogoBounds = null;
  var pendingPlacement = false;
  var revealed = false;
  var EDGE_GAP = 33;
  var MOBILE_BREAKPOINT = 767;

  function revealAll() {
    if (revealed) return;
    revealed = true;
    var logo = document.querySelector('#header-inner #logo');
    var burgerWrap = document.querySelector('#header-inner .link-btn');
    var navUser = document.querySelector('#header-inner #nav-user');
    if (logo) logo.style.visibility = 'visible';
    if (burgerWrap) burgerWrap.style.visibility = 'visible';
    if (navUser) navUser.style.visibility = 'visible';
  }

  setTimeout(revealAll, 2000);

  function getVisibleBounds(imgUrl) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          var left = canvas.width, right = 0;
          for (var y = 0; y < canvas.height; y++) {
            for (var x = 0; x < canvas.width; x++) {
              var alpha = data[(y * canvas.width + x) * 4 + 3];
              if (alpha > 10) {
                if (x < left) left = x;
                if (x > right) right = x;
              }
            }
          }
          resolve({ left: left, right: right, naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight });
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = function () { resolve(null); };
      img.src = imgUrl;
    });
  }

  function alignHeaderHome() {
    var logo = document.querySelector('#header-inner #logo');
    var logoLink = logo ? logo.querySelector('a') : null;
    var burgerWrap = document.querySelector('#header-inner .link-btn');
    var headerInner = document.querySelector('#header-inner');
    var navUser = document.querySelector('#header-inner #nav-user');
    if (!logo || !logoLink || !burgerWrap || !headerInner) {
      revealAll();
      return;
    }

    headerInner.style.position = 'relative';

    var headerRect = headerInner.getBoundingClientRect();
    var leftGutter = headerRect.left;
    var rightGutter = window.innerWidth - headerRect.right;
    var leftBase = EDGE_GAP - leftGutter;
    var rightBase = EDGE_GAP - rightGutter;

    if (navUser) {
      navUser.style.position = 'absolute';
      navUser.style.margin = '0';
      navUser.style.left = '';
      navUser.style.right = rightBase + 'px';
    }

    var logoBoxRect = logoLink.getBoundingClientRect();
    var boxWidth = logoBoxRect.width;
    var boxHeight = logoBoxRect.height;

    function place(bounds) {
      var visLeftInBox, visWidthInBox;
      if (bounds && bounds.right > bounds.left) {
        var scale = Math.min(boxWidth / bounds.naturalWidth, boxHeight / bounds.naturalHeight);
        var dispW = bounds.naturalWidth * scale;
        var offsetX = (boxWidth - dispW) / 2;
        visLeftInBox = offsetX + bounds.left * scale;
        visWidthInBox = (bounds.right - bounds.left) * scale;
      } else {
        visLeftInBox = 0;
        visWidthInBox = boxWidth;
      }

      logo.style.position = 'absolute';
      logo.style.margin = '0';
      logo.style.left = (leftBase - visLeftInBox) + 'px';

      var rightInset = Math.max(0, boxWidth - visLeftInBox - visWidthInBox);
      logoLink.style.clipPath = 'inset(0 ' + rightInset + 'px 0 ' + visLeftInBox + 'px)';

      var gap = 20;
      burgerWrap.style.position = 'absolute';
      burgerWrap.style.margin = '0';
      burgerWrap.style.left = (leftBase + visWidthInBox + gap) + 'px';

      revealAll();
    }

    if (cachedLogoBounds !== null) {
      place(cachedLogoBounds);
      return;
    }
    if (pendingPlacement) return;
    pendingPlacement = true;

    var bg = getComputedStyle(logoLink).backgroundImage;
    var match = bg.match(/url\(["']?(.*?)["']?\)/);
    var imgUrl = match ? match[1] : null;

    if (imgUrl) {
      getVisibleBounds(imgUrl).then(function (bounds) {
        cachedLogoBounds = bounds || false;
        pendingPlacement = false;
        place(bounds);
      });
    } else {
      cachedLogoBounds = false;
      pendingPlacement = false;
      place(null);
    }
  }

  var MOBILE_MENU_ID = 'ming-mobile-menu-btn';

  function ensureVisibleMenuButton(menuLink) {
    var existing = document.getElementById(MOBILE_MENU_ID);
    if (existing) return existing;

    var icon = document.createElement('span');
    icon.id = MOBILE_MENU_ID;
    icon.setAttribute('aria-hidden', 'true');
    icon.style.cssText = [
      'display:flex !important',
      'flex-direction:column !important',
      'justify-content:space-between !important',
      'flex-shrink:0 !important',
      'width:22px !important',
      'min-width:22px !important',
      'max-width:none !important',
      'height:16px !important',
      'min-height:16px !important',
      'position:relative !important',
      'z-index:5 !important'
    ].join(';');

    for (var i = 0; i < 3; i++) {
      var bar = document.createElement('span');
      bar.style.cssText = [
        'display:block !important',
        'width:22px !important',
        'min-width:22px !important',
        'height:2px !important',
        'flex-shrink:0 !important',
        'background-color:#ffffff !important',
        'border-radius:1px !important'
      ].join(';');
      icon.appendChild(bar);
    }

    menuLink.insertBefore(icon, menuLink.firstChild);
    return icon;
  }

  function forceInnerPageMobileHeader() {
    var headerInner = document.querySelector('#header-inner');
    var burgerWrap = document.querySelector('#header-inner .link-btn');
    var firstLink = burgerWrap ? burgerWrap.querySelector('a:first-child') : null;
    var navUser = document.querySelector('#header-inner #nav-user');
    var logo = document.querySelector('#header-inner #logo');
    var logoLink = logo ? logo.querySelector('a') : null;
    if (!headerInner || !burgerWrap || !firstLink) return;

    function force(el, props) {
      for (var k in props) el.style.setProperty(k, props[k], 'important');
    }

    force(headerInner, {
      position: 'relative',
      display: 'flex', 'align-items': 'center', 'justify-content': 'flex-start',
      height: '56px', 'min-height': '56px',
      'padding-left': '16px', 'padding-right': '33px', 'box-sizing': 'border-box'
    });
    force(burgerWrap, {
      position: 'static', display: 'flex', 'align-items': 'center',
      opacity: '1', visibility: 'visible',
      width: '22px', 'min-width': '22px', 'max-width': 'none',
      height: '32px', 'min-height': '32px',
      padding: '0', margin: '0'
    });
    force(firstLink, {
      position: 'static', display: 'flex', 'align-items': 'center',
      opacity: '1', visibility: 'visible',
      width: '22px', 'min-width': '22px', 'max-width': 'none',
      height: '32px', 'min-height': '32px',
      padding: '0'
    });

    ensureVisibleMenuButton(firstLink);

    if (navUser) {
      force(navUser, { position: 'static', margin: '0', 'margin-left': 'auto' });
    }

    // Logo vraiment centre au milieu de la bande, independamment du
    // menu (gauche) et du panier/compte (droite).
    if (logo && logoLink) {
      force(logo, {
        position: 'absolute', margin: '0',
        left: '50%', top: '50%', transform: 'translate(-50%, -50%)'
      });
    }
  }

  function alignHeader() {
    if (!document.body.classList.contains('template-index')) {
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        forceInnerPageMobileHeader();
      }
      revealAll();
      return;
    }
    alignHeaderHome();
  }

  function alignHeaderRepeatedly() {
    var attempts = 0;
    var maxAttempts = 15;
    var interval = setInterval(function () {
      alignHeader();
      attempts++;
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 300);
  }

  alignHeader();
  document.addEventListener('DOMContentLoaded', alignHeaderRepeatedly);
  window.addEventListener('load', alignHeaderRepeatedly);
  window.addEventListener('resize', alignHeader);
})();
